import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="drag-drop"
export default class extends Controller {
  static values = {
    allowedFileTypes: Array,
    allowMultipleAttachement: Boolean,
    displayProcessing: Boolean,
  };
  static targets = [
    "input",
    "icon",
    "inputContainer",
    "submitContainer",
    "dragZone",
  ];

  connect() {
    this.dragZone = this.hasDragZoneTarget ? this.dragZoneTarget : this.element;
    this.dragZone.addEventListener("dragover", this.dragOver.bind(this));
    this.dragZone.addEventListener("dragleave", this.dragLeave.bind(this));
    this.dragZone.addEventListener("drop", this.drop.bind(this));
  }

  disconnect() {
    this.dragZone.removeEventListener("dragover", this.dragOver.bind(this));
    this.dragZone.removeEventListener("dragleave", this.dragLeave.bind(this));
    this.dragZone.removeEventListener("drop", this.drop.bind(this));
  }

  dragOver(event) {
    event.preventDefault();
    this.#successFixState();
  }

  dragLeave(event) {
    event.preventDefault();
    this.iconTarget.classList.remove("bg-white");
    this.iconTarget.classList.add("bg-neutral");
    this.dragZone.removeAttribute("data-state");
  }

  drop(event) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length > 1 && !this.allowMultipleAttachementValue) {
      this.#displayError();
    } else {
      this.inputTarget.files = files;
      this.submit();
    }
  }

  submit() {
    if (this.#isAuthorizedFiles()) {
      const associatedModal = document.getElementById("modal").querySelector("dialog");
      associatedModal?.dispatchEvent(new CustomEvent("modal:lock"));
      this.#displaySuccess();
      this.element.requestSubmit();
    } else {
      this.#displayError();
    }
  }

  #isAuthorizedFiles() {
    const types = this.#findTypes();
    const isInvalid = types.some(
      (type) => !this.allowedFileTypesValue.includes(type),
    );
    if (isInvalid) {
      this.#displayError();
      return false
    } else {
      this.#successFixState();
      return true
    }
  }

  #successFixState() {
    this.iconTarget.classList.add("bg-white");
    this.iconTarget.classList.remove("bg-neutral");
    this.dragZone.dataset.state = "dragging";
  }

  #displaySuccess() {
    if (this.displayProcessingValue) {
      this.inputContainerTarget.classList.add("hidden");
      this.submitContainerTarget.classList.remove("hidden");
      this.dragZone.dataset.state = "success";
    } else {
      this.dragZone.removeAttribute("data-state");
    }
  }

  #displayError() {
    this.dragZone.dataset.state = "error";
  }

  #findTypes() {
    return Array.from(this.inputTarget.files).map((file) => file.type);
  }
}
